'use client';
import Navigation, {
  NavigationProps as BaseNavigationProps,
} from '@repo/ui/src/components/Navigation';
import MeaterNavbarBrand from './MeaterNavbarBrand';
import MeaterNavbarShoppingCart from './_ShoppingCart';
import MeaterLanguageSelectorData from '@components/LanguageSelector/MeaterLanguageSelectorData.json';
import React from 'react';

// Extend the base props for meater-specific requirements
export interface NavigationProps {
  searchLink?: BaseNavigationProps['searchLink'];
  navItems?: BaseNavigationProps['navItems'];
  sitewideBanner?: BaseNavigationProps['sitewideBanner'];
  regions?: BaseNavigationProps['regions'];
  NavbarBrand?: React.ComponentType;
  NavbarShoppingCart?: React.ComponentType;
  UserAvatar?: React.ComponentType<{
    className?: string;
    loggedInLabel?: string;
    loggedOutText?: string;
  }>;
  account?: BaseNavigationProps['account'];
  SocialLinks?: React.ComponentType<{ socialLinks: any }>;
  _schema?: string;
}

// Re-export types and components that other components might need
export type {
  NavItemProps,
  NavDropdownProps,
  SecondaryNavProps,
  LinkGroupProps,
  LinkWithIconProps,
  LinkListProps,
} from '@repo/ui/src/components/Navigation';
export {
  isDropdown,
  useNavigationContext,
  NavDropdown,
  SecondaryNav,
  LinkGroup,
  LinkList,
  ProductList,
} from '@repo/ui/src/components/Navigation';

const MeaterNavigation = (props: NavigationProps) => {
  return (
    <Navigation
      {...(props as BaseNavigationProps)}
      regions={props.regions || MeaterLanguageSelectorData.regions}
      NavbarBrand={props.NavbarBrand || MeaterNavbarBrand}
      NavbarShoppingCart={props.NavbarShoppingCart || MeaterNavbarShoppingCart}
      vip={false}
    />
  );
};

export default MeaterNavigation;
